import React from 'react';

/**
 * Reusable admin inner page wrapper for consistent UI/UX.
 * Use for all admin list/detail pages: optional back link, title, description, actions slot, content.
 * Pass `back` as a React node (e.g. icon + "Back to X") for intuitive navigation.
 */
function AdminPage({ back, title, description, actions, children, noPadding }) {
  return (
    <div className="admin-page min-h-0">
      {(back || title || actions) && (
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
          <div className="min-w-0">
            {(back || title) && (
              <div className="flex items-center gap-3 min-w-0">
                {back && <div className="flex-shrink-0">{back}</div>}
                {title && (
                  <h1 className="text-xl sm:text-2xl font-semibold text-gray-900 tracking-tight truncate">
                    {title}
                  </h1>
                )}
              </div>
            )}
            {description && (
              <p className="text-gray-500 text-sm sm:text-base mt-1 max-w-2xl">
                {description}
              </p>
            )}
          </div>
          {actions && <div className="flex items-center gap-2 flex-shrink-0">{actions}</div>}
        </div>
      )}
      <div className={noPadding ? '' : 'pt-0'}>{children}</div>
    </div>
  );
}

export default AdminPage;
